import { render, staticRenderFns } from "./InputInfo.vue?vue&type=template&id=3597b349&scoped=true&"
import script from "./InputInfo.vue?vue&type=script&lang=js&"
export * from "./InputInfo.vue?vue&type=script&lang=js&"
import style0 from "./InputInfo.vue?vue&type=style&index=0&id=3597b349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597b349",
  null
  
)

export default component.exports